import { asPage } from 'src/components/hoc/asPage'
import { UserProfileEditor } from 'src/compositions/Profile/UserProfile'

export default asPage(UserProfileEditor, { pageTitle: 'プロフィールの編集' })
